import styled from 'styled-components';
import { palette } from 'styles/colors';
import { layout } from 'styles/layout';
import Image from '../../elements/image/image';

// max-width !important is needed to override the layout max-width: 1440px constraint;
export const TrustedByContainer = styled.div`
  max-width: 100vw !important;
  background: radial-gradient(120.33% 2238.87% at 52.92% 49.85%,#963481 0,#963481 29.51%,#2d263b 71%);

  & > div {
    display: grid;
    padding: 2em 17px 3em;
    row-gap: 3em;
    & > h1 {
      color: ${palette.white}
    }
  }
`

export const TrustedByLogoContainer = styled.div`
  max-width: 1440px;
  width: 100%;
  justify-self: center;
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  & > div {
    max-width: 125px;
    flex: 1 1 0px;
    filter: brightness(800%);
  }


  @media all and (max-width: ${layout.md}) {
    display: grid;
    column-gap: 50px;
    row-gap: 1rem;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(3, 1fr);

    & > div {
      width: 100%;
      justify-self: center;
      align-self: center;
    }
  }
`

export const TrustedByLogo = styled(Image)`
  /* Safari 11+ */
  @media not all and (min-resolution:.001dpcm)
  { @supports (-webkit-appearance:none) and (stroke-color:transparent) {
    img:only-of-type {
      will-change: initial;
      transform: initial;
    }
  }}

  /* Safari 10.1 */
  @media not all and (min-resolution:.001dpcm){
    @supports (-webkit-appearance:none) and (not (stroke-color:transparent)) {
      img:only-of-type {
        will-change: initial;
        transform: initial;
      }
    }}

  /* Safari 6.1-10.0 (but not 10.1) */
  @media screen and (min-color-index:0) and(-webkit-min-device-pixel-ratio:0){
    @media {
      img:only-of-type {
        will-change: initial;
        transform: initial;
      }
    }}
`

